import BaseView from './utilities/baseView.js';
import Search from './modules/ApartmentSearch/search.js';
import SliderCounter from './utilities/slider-counter.js';
import { tns } from "tiny-slider";
import SearchFilters from './modules/SearchFilters/index.js';
import Selectpicker from './utilities/selectpicker.js';
import MapSection from './modules/ObjectsList/mapSection.js';
import ImgLazyLoader from "./utilities/imgLazyLoader.js";

class RegionsObjectsListView extends BaseView {
    sliderCounter = null;
    sliders = document.querySelectorAll('.object-slider');

    textContainer = document.querySelector('.text');
    moreContainer = document.querySelector('.more');
    moreButtons = null;

    search = null;
    favourites = null;
    map = null;

    constructor() {
        // ! TODO: cały ten plik jest identyczny jak objectListView.js oraz recommendedObjectsListView.js.js - najlepiej byłoby zunifikować widoki i backend, ale jeśli się nie da to można pomyśleć nad wydzieleniem modułów z tego co jest tutaj i reużyciem w odpowiednich miejscach
        super(objectsListConfig);
        new Selectpicker();
        this.filters = new SearchFilters(searchFiltersConfig, this.notification);
        this.search = new Search(
            apartmentSearchConfig, 
            this.notification, 
            this.loader, 
            false, 
            false, 
            this.filters
        );
        this.sliderCounter = new SliderCounter();
        this.mapSection = new MapSection(this.settings, true);
        this.lazyLoader = new ImgLazyLoader(
            document.querySelector(".objects-list")
        );
        this.prepareObjectsLazyLoader();
        this.preparePhotosSliders();
        this.bindSwitcher();
        this.bindSortButton();
        this.bindObjectHover();
        this.resizeMobileObjectsContainers();

        if (this.moreContainer !== null) {
            this.moreButtons = this.moreContainer.querySelectorAll("p");
            this.prepareShowMoreModule();
        }

        document.addEventListener('resize', () => {
            this.resizeMobileObjectsContainers();
        });
        //this.toggleMore();
    }

    preparePhotosSliders = () => {
        this.sliders.forEach(slider => {
            const tinySLider = tns({
                preventScrollOnTouch: 'force',
                container: slider,
                items: 1,
                nav: false,
                mouseDrag: true,
                center: false,
                controls: true,
                swipeAngle: false,
                arrowKeys: true
            });

            if (tinySLider !== undefined) {
                tinySLider.events.on('indexChanged', (data, eventName) => {
                    this.sliderCounter.add(data);
                });
            }
        });
    }

    prepareShowMoreModule = () => {
        this.moreButtons.forEach((button) => {
            button.addEventListener("click", () => {
                this.toggleMore();
            });
        });
    }

    toggleMore = () => {
        const { moreContainer, textContainer } = this;

        moreContainer.classList.toggle('open');
        textContainer.classList.toggle('open');
    }

    bindSwitcher = () => {
        const objectsData = document.getElementById("objectsData");
        const objectsMap = document.getElementById("objectsMap");
        const switchToMapButton = document.getElementById("switchToMap");
        const switchToDataButton = document.getElementById("switchToData");

        [switchToMapButton, switchToDataButton].forEach(button => {
            button.addEventListener('click', () => {
                objectsMap.classList.toggle('visible');
                objectsData.classList.toggle('visible');
                this.mapSection.map.invalidateSize();

                if (button.id === "switchToData") {
                    const switchButton = document.getElementById('switchToData');
                    const objects = this.mapSection.container.querySelectorAll('.object--popup');
                    objects.forEach(object => object.remove());
                    switchButton.style.removeProperty("bottom");
                }
            });
        });
    }

    bindSortButton = () => {
        const button = document.querySelector('.sorter');
        const sorterIcons = document.querySelector('.sorter__icons');

        button.addEventListener('click', () => {
            const sortType = sorterIcons.classList.contains("asc") ? "asc" : "desc";
            this.search.triggerSearchBySort(sortType);
        });
    }

    bindObjectHover = () => {
        const objects = document.querySelectorAll(".object");

        objects.forEach((object) => {
            object.addEventListener("mouseenter", () => {
                const objectId = object.dataset.id;
                const marker = document.querySelector(`.object-marker[data-marker-id="${objectId}"]`);
                if (marker !== null) {
                    marker.classList.add("active");
                    marker.parentElement.dataset.zIndex = marker.parentElement.style.zIndex;
                    marker.parentElement.style.zIndex = "3000";
                }
            });
            object.addEventListener("mouseleave", () => {
                const objectId = object.dataset.id;
                const marker = document.querySelector(
                    `.object-marker[data-marker-id="${objectId}"]`
                );
                if (marker !== null) {
                    marker.classList.remove("active");
                    marker.parentElement.style.zIndex = marker.parentElement.dataset.zIndex;
                }
            });
        });
    };

    resizeMobileObjectsContainers = () => {
        const objectsFiltersContainer = document.querySelector('.objects-filters-container');
        const objectDescriptionHeight = 158;
        const searchHeader = document.querySelector('.search-header');
        let height = window.innerHeight - objectsFiltersContainer.offsetHeight - searchHeader.offsetHeight - objectDescriptionHeight;

        if (height <= 400) {
            height = '100vh';
        } else {
            height += "px";
        }

        document.querySelector('.objects__data').style.height = document.body.clientWidth <= 900 ? height : null;
        document.querySelector('.objects__map').style.height = document.body.clientWidth <= 900 ? height : null;
    }

    prepareObjectsLazyLoader = () => {
        const container = document.querySelector(".objects-list");
        const objects = Array.from(container.querySelectorAll(".object:not(.object-near)"));
        const objectsNear = Array.from(container.querySelectorAll(".object-near"));
        const alert = container.querySelectorAll(".alert")[1];
        const toDisplay = [];
        const toDisplayNear = [];
        let lastObjectIndex = 0;

        alert?.remove();
    
        objects.forEach((object, index) => {
            lastObjectIndex++;
            if (index > 5) {
                toDisplay.push(object.cloneNode(true));
                object.remove();
            }
        });
    
        objectsNear.forEach((object, index) => {
            if (lastObjectIndex < 4 && index === 0 && toDisplay.length === 0) {
                container.insertBefore(alert, object);
            }
    
            if (lastObjectIndex < 4) {
                lastObjectIndex++;
            } else {
                toDisplayNear.push(object.cloneNode(true));
                object.remove();
            }
        });
    
        const loadMoreObjects = () => {
            let objectsAppended = 0;
    
            while (objectsAppended < 3 && toDisplay.length) {
                const object = toDisplay.pop();
                if (object) {
                    container.appendChild(object);
                    this.lazyLoader.singleImageLoad(object.querySelector('.object-slider__item img'));
                    objectsAppended++;
                }
            }
    
            while (objectsAppended < 3 && toDisplayNear.length && container.contains(alert)) {
                const object = toDisplayNear.pop();
                if (object) {
                    container.appendChild(object);
                    this.lazyLoader.singleImageLoad(object.querySelector('.object-slider__item img'));
                    objectsAppended++;
                }
            }
    
            if (toDisplay.length === 0 /* && toDisplayNear.length === 0 */ && !container.contains(alert)) {
                container.appendChild(alert);
            }
        };
    
        const checkAndLoadMore = () => {
            if (container.scrollHeight <= container.clientHeight) {
                loadMoreObjects();
                setTimeout(checkAndLoadMore, 100);
            }
        };
    
        container.addEventListener('scroll', () => {
            if (container.scrollTop + container.clientHeight + 200 >= container.scrollHeight) {
                loadMoreObjects();
            }
        });
    
        checkAndLoadMore();
    }
}

new RegionsObjectsListView();